var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.526 6.59557C5.8365 6.59557 6.0885 6.84757 6.0885 7.15807C6.0885 7.46857 5.8365 7.72057 5.526 7.72057H4.82625C3.612 7.72057 2.625 8.70757 2.625 9.92107V13.5773C2.625 14.7916 3.612 15.7786 4.82625 15.7786H13.1737C14.3873 15.7786 15.375 14.7916 15.375 13.5773V9.91432C15.375 8.70457 14.391 7.72057 13.182 7.72057H12.4748C12.1643 7.72057 11.9123 7.46857 11.9123 7.15807C11.9123 6.84757 12.1643 6.59557 12.4748 6.59557H13.182C15.0113 6.59557 16.5 8.08432 16.5 9.91432V13.5773C16.5 15.4118 15.0075 16.9036 13.1737 16.9036H4.82625C2.9925 16.9036 1.5 15.4118 1.5 13.5773V9.92107C1.5 8.08732 2.9925 6.59557 4.82625 6.59557H5.526ZM9.39795 1.66627L11.5849 3.86227C11.804 4.08277 11.8032 4.43827 11.5835 4.65727C11.363 4.87627 11.0075 4.87627 10.7885 4.65577L9.56175 3.42483L9.5622 11.6557H8.4372L8.43675 3.42483L7.2117 4.65577C7.1022 4.76677 6.95745 4.82152 6.81345 4.82152C6.6702 4.82152 6.5262 4.76677 6.4167 4.65727C6.19695 4.43827 6.19545 4.08277 6.4152 3.86227L8.60145 1.66627C8.8122 1.45402 9.1872 1.45402 9.39795 1.66627Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bf3146e4.svg";
export { ForwardRef as ReactComponent };